import { ToolbarFocusButton } from '@editor/assets/icons'
import { EDITOR_TOOLS, EDITOR_TOOLS_LABELS, EDITOR_TOOL_BUTTON_SIZE } from '@editor/config/constants'
import ToolbarButton from '@editor/pages/projects/editor/toolbar/components/ToolbarButton'

/**
 * Camera focus button.
 * This component is being imported by CameraProfile's CameraToolbar component.
 */
const CameraFocusButton = ({
  selectedTool,
  changeTool,
}: {
  selectedTool: string
  changeTool: (tool: string) => void
}) => (
  <ToolbarButton
    icon={<ToolbarFocusButton size="50%" />}
    label={EDITOR_TOOLS_LABELS.FOCUS}
    toolType={EDITOR_TOOLS.FOCUS}
    buttonSize={EDITOR_TOOL_BUTTON_SIZE}
    selectedTool={selectedTool}
    changeTool={changeTool}
    toolTipPlacement="top"
  />
)

export default CameraFocusButton
